import {Dimension as GraphQLDimension} from '../../../../../globalTypes';


export enum Dimension {
    Time = 'DATE',
    ATTRIBUTION_SOURCE_APP = 'ATTRIBUTION_SOURCE_APP',
    App = 'APP',
    User = 'USER',
    InstallDate = 'INSTALL_DATE',
    AdType = 'AD_TYPE',
    DisplayAdType = 'DISPLAY_AD_TYPE',
    Country = 'COUNTRY',
    AdNetwork = 'AD_NETWORK',
    campaign = 'campaign',
    LineItem = 'LINE_ITEM',
    Placement = 'PLACEMENT',
    Segment = 'SEGMENT',
    OS = 'OS',
    package_version = 'PACKAGE_VERSION',
    install_package_version = 'INSTALL_PACKAGE_VERSION',
    sdk_version = 'SDK_VERSION',
    os_version = 'OS_VERSION',
    ZeroIdfa = 'ZERO_IDFA',
    ZeroMMPId = 'ZERO_MMP_ID',
    manufacturer = 'MANUFACTURER',
    model = 'MODEL',
    device_type = 'DEVICE_TYPE',
    attribution_network = 'ATTRIBUTION_NETWORK',
    attribution_campaign = 'ATTRIBUTION_CAMPAIGN',
    attribution_ad_set = 'ATTRIBUTION_AD_SET',
    attribution_creative = 'ATTRIBUTION_CREATIVE',
    attribution_network_hid = 'ATTRIBUTION_NETWORK_HID',
    attribution_campaign_hid = 'ATTRIBUTION_CAMPAIGN_HID',
    attribution_ad_set_hid = 'ATTRIBUTION_AD_SET_HID',
    attribution_creative_hid = 'ATTRIBUTION_CREATIVE_HID',
    keywords = 'KEYWORDS',
    attribution_search_keywords = 'ATTRIBUTION_SEARCH_KEYWORDS',
    attribution_search_keywords_ids = 'ATTRIBUTION_SEARCH_KEYWORDS_IDS',
    attribution_campaign_status = 'ATTRIBUTION_CAMPAIGN_STATUS',
    ua_status = 'UA_STATUS',
    auto_bid = 'AUTO_BID',
    hist_campaign_status = 'HIST_CAMPAIGN_STATUS',
    hist_campaign_type = 'HIST_CAMPAIGN_TYPE',
    hist_campaign_auto_bid = 'HIST_CAMPAIGN_AUTO_BID',
    hist_campaign_payback_period = 'HIST_CAMPAIGN_PAYBACK_PERIOD',
    hist_ad_set_status = 'HIST_AD_SET_STATUS',
    hist_ad_set_auto_bid = 'HIST_AD_SET_AUTO_BID',
    hist_ad_set_payback_period = 'HIST_AD_SET_PAYBACK_PERIOD',
    hist_country_status = 'HIST_COUNTRY_STATUS',
    hist_country_auto_bid = 'HIST_COUNTRY_AUTO_BID',
    hist_country_payback_period = 'HIST_COUNTRY_PAYBACK_PERIOD',
    hist_source_app_status = 'HIST_SOURCE_APP_STATUS',
    hist_source_app_auto_bid = 'HIST_SOURCE_APP_AUTO_BID',
    hist_source_app_payback_period = 'HIST_SOURCE_APP_PAYBACK_PERIOD',
    mmp = 'MMP',
    parallel_bidding = 'PARALLEL_BIDDING',
    waterfall_configuration = 'WATERFALL_CONFIGURATION',
    day_since_install = 'DAY_SINCE_INSTALL',
    post_bid = 'POST_BID',
    round_number = 'ROUND_NUMBER',
    ad_request_floor_range = 'AD_REQUEST_FLOOR_RANGE',
    bid_floor_range = 'BID_FLOOR_RANGE',
    bid_price_range = 'BID_PRICE_RANGE',
    white_label_publisher = 'WHITE_LABEL_PUBLISHER',
    funnel = 'FUNNEL',
    is_organic = 'IS_ORGANIC',
    bidmanager_creative_hid = 'BIDMANAGER_CREATIVE_HID',
    appodeal_account = 'APPODEAL_ACCOUNT',
    mediation = 'MEDIATION',
    mediation_group = 'MEDIATION_GROUP',
    install_mediation = 'INSTALL_MEDIATION',
    event_name = 'EVENT_NAME',
    event_source = 'EVENT_SOURCE',
    is_chardonnay = 'IS_CHARDONNAY',
    monetization_engine = 'MONETIZATION_ENGINE',
    user_created_date = 'USER_CREATED_DATE',
    app_created_date = 'APP_CREATED_DATE',
    studio = 'STUDIO',
    revenue_manager = 'REVENUE_MANAGER',
    attribution_agency = 'ATTRIBUTION_AGENCY',
    is_claimed_by_publisher = 'IS_CLAIMED_BY_PUBLISHER'
}

export enum KnownMeasure {
    Impressions = 'impressions',
    Clicks = 'clicks',
    Requests = 'requests',
    Fills = 'fills',
    Finish = 'view',
    SessionsCount = 'session_count',
    DisplayRate = 'display_rate',
    ActiveUsersPerAd = 'dau',
    ActiveUsers = 'dau_full',
    DAU = 'real_dau',
    ARPDAU = 'arpdau',
    IAP_ARPDAU = 'iap_arpdau',
    TOTAL_ARPDAU = 'total_arpdau',
    ManagedARPDAU = 'managed_arpdau',
    TotalManagedARPDAU = 'total_managed_arpdau',
    AFPDAU = 'afpdau',
    AdEngagedUsers = 'ad_deu',
    PayingUsers = 'dpu',
    PayingUserConversion = 'paying_user_conversion',

    NumberOfPurchases = 'number_of_purchases',
    AdRevenue = 'ad_revenue',

    AvgTimeSpentPerUser = 'avg_device_session_length',
    AvgTimeSpentPerUserLifeTime = 'avg_time_per_user_per_lifetime',
    AvgTimeSpentPerUserDaily = 'avg_time_per_user_per_day',
    AvgTimeSpentPerUserMonthly = 'avg_time_per_user_per_month',

    AvgUserSessionLength = 'avg_user_session_length',
    AvgSessionCountPerDevice = 'avg_device_sessions',
    AvgSessionCountPerDaily = 'avg_device_sessions_daily',
    AvgSessionCountPerMonthly = 'avg_device_sessions_monthly',
    AvgSessionCountPerLifeTime = 'avg_device_sessions_lifetime',
    DeviceImpressionsCount = 'avg_device_impressions',
    DeviceImpressionsCountDaily = 'avg_device_impressions_daily',
    DeviceImpressionsCountMonthly = 'avg_device_impressions_monthly',
    DeviceImpressionsCountLifeTime = 'avg_device_impressions_lifetime',
    ImpressionsPerSession = 'avg_session_impressions',
    FullSessionLength = 'avg_full_session_length',
    FullTimeSpentPerUser = 'avg_full_device_session_length',
    AvgFullTimeSpentPerUserLifeTime = 'avg_full_time_per_user_per_lifetime',
    AvgFullTimeSpentPerUserDaily = 'avg_full_time_per_user_per_day',
    AvgFullTimeSpentPerUserMonthly = 'avg_full_time_per_user_per_month',
    TimePerUserDayN = 'time_per_user_day_n',

    EngagementRate = 'engagement_rate',
    Fillrate = 'fillrate',
    Ctr = 'ctr',
    Ecpm = 'ecpm',
    RetentionRate = 'retention_rate',
    RetentionRateOrganic = 'retention_rate_organic',
    RetentionRateForecast = 'retention_rate_forecast',
    Whales = 'whales',
    EcpmDecay = 'ecpm_decay',
    Arpeu = 'ad_arpeu',
    AdArpu = 'ad_arpu',
    Arpu = 'arpu',
    AFPU = 'afpu',
    Arppu = 'arppu',
    IapArpu = 'iap_arpu',
    IapArppu = 'iap_arppu',
    Roas = 'roas',
    eRoasToDate = 'e_roas',
    eRoasWithAgencyProfitShareToDate = 'e_roas_with_agency_profit_share',
    RoasActual = 'roas_actual',
    ProfitLoss = 'profit_loss',
    ProfitLossWithAgencyProfitShare = 'profit_loss_with_agency_profit_share',
    HistCampPredictBid = 'hist_campaign_predicted_bid',

    RevenueForecast = 'revenue_forecast',
    CumulativeAdRevenueForecast = 'cumulative_ad_revenue_forecast',
    CumulativeIapRevenueForecast = 'cumulative_iap_revenue_forecast',
    ArpeuForecast = 'arpeu_forecast',
    RoasForecast = 'roas_forecast',
    ProfitForecast = 'profit_forecast',
    Profit = 'profit',

    Cpi = 'cpi',
    CostPerNetworkInstall = 'cost_per_network_install',
    Cpm = 'cpm_ua',
    Spend = 'spend',
    Installs = 'installs',
    AttributedInstalls = 'attributed_installs',
    NetworkInstalls = 'network_installs',
    AttributionCosts = 'attribution_costs',
    IPM = 'ipm',
    CtrUA = 'ctr_ua',
    CvrUA = 'cvr_ua',
    ClicksUA = 'click_count_ua',
    ImpressionsUA = 'impression_count_ua',

    SessionLength = 'avg_session_length',
    ManagedRevenue = 'managed_ad_revenue',
    ManagedEcpm = 'managed_ecpm',


    MediationFee = 'mediation_fee',
    MediationFeePercent = 'fee_percent',
    DemandFee = 'demand_fee',
    TotalFee = 'total_fee',

    AdsRevenue = 'ad_revenue',

    TotalPurchasesCount = 'number_of_purchases',
    PurchasesPerPayingUser = 'purchases_per_paying_user',
    PurchasesPerUser = 'purchases_per_user',

    IapRevenue = 'iap_revenue',
    IapRefunds = 'iap_refunds',
    IapRevenueBeforeFees = 'iap_revenue_before_fees',
    IapRevenueAfterRefunds = 'iap_revenue_after_refunds',
    SubsRevenue = 'subscriptions_revenue',

    RevisedClicksCount = 'revised_clicks_count',
    RevisedClicks = 'revised_clicks',
    RevisedImpressionsCount = 'revised_impressions_count',
    RevisedImpressions = 'revised_impressions',
    RevisedCtr = 'revised_ctr',
    RevisedEcpm = 'revised_ecpm',
    TotalRevenue = 'total_revenue',
    IosTotalRevenue = 'ios_total_revenue',
    ATTOptInRate = 'tracking_authorized_rate',

    CumulativeRevenue = 'cumulative_revenue',
    CumulativeRevenueForecast = 'cumulative_revenue_forecast',

    CumulativeARPU = 'cumulative_arpu',
    CumulativeARPUForecast = 'cumulative_arpu_forecast',
    CumulativeAdARPUForecast = 'cumulative_ad_arpu_forecast',
    CumulativeInApARPUForecast = 'cumulative_iap_arpu_forecast',
    CumulativeInApARPPUForecast = 'cumulative_iap_arppu_forecast',
    CumulativeCostPerBuyer = 'cumulative_cost_per_buyer',
    CumulativeConversionToBuyer = 'cumulative_conversion_to_buyer',

    eRevenue = 'e_revenue_forecast',
    eProfit = 'e_profit_forecast',
    eProfitForecastWithAgencyProfitShare = 'e_profit_forecast_with_agency_profit_share',
    eROAS = 'e_roas_forecast',
    eROASWithAgencyProfitShare = 'e_roas_forecast_with_agency_profit_share',
    eLTV = 'e_arpu_forecast',
    eInstalls = 'e_installs',

    BudgetUsedPercent = 'budget_used_percent',

    TotalRevenueCalendar = 'total_revenue_calendar',
    TotalRevenueCohort = 'total_revenue_cohort',
    AgencyProfitShare = 'agency_profit_share',
    AgencyProfitShareCalendar = 'agency_profit_share_calendar',
    AgencyProfitShareCohort = 'agency_profit_share_cohort',
    MediaSpend = 'media_spend',
    MediaProfit = 'media_profit',
    MediaProfitCalendar = 'media_profit_calendar',
    MediaProfitCohort = 'media_profit_cohort',
    MediaProfitForecast = 'media_profit_forecast',
    MediaRoas = 'media_roas',
    MediaRoasCalendar = 'media_roas_calendar',
    MediaRoasCohort = 'media_roas_cohort',
    MediaRoasForecast = 'media_roas_forecast',
    MarketingCosts = 'marketing_costs',
    MarketingCostsCalendar = 'marketing_costs_calendar',
    MarketingCostsCohort = 'marketing_costs_cohort',
    MarketingProfit = 'marketing_profit',
    MarketingProfitCalendar = 'marketing_profit_calendar',
    MarketingProfitCohort = 'marketing_profit_cohort',
    MarketingProfitForecast = 'marketing_profit_forecast',

    Romi = 'romi',
    RomiToDate = 'romi_to_date',
    RomiCalendar = 'romi_calendar',
    RomiCohort = 'romi_cohort',
    RomiForecast = 'romi_forecast',

    ChardonnayExpenses = 'chardonnay_expenses',
    ChardonnayExpensesCalendar = 'chardonnay_expenses_calendar',
    ChardonnayExpensesCohort = 'chardonnay_expenses_cohort',
    ChardonnayProfit = 'chardonnay_profit',
    ChardonnayProfitCalendar = 'chardonnay_profit_calendar',
    ChardonnayProfitCohort = 'chardonnay_profit_cohort',
    ChardonnayRoi = 'chardonnay_roi',
    ChardonnayRoiToDate = 'chardonnay_roi_to_date',
    ChardonnayRoiCalendar = 'chardonnay_roi_calendar',
    ChardonnayRoiCohort = 'chardonnay_roi_cohort',
    ChardonnayRoiForecast = 'chardonnay_roi_forecast',

    WhiteLabelGrossProfitWithAps = 'wl_gross_profit_with_aps',
    WhiteLabelGrossProfitWithApsCalendar = 'wl_gross_profit_with_aps_calendar',
    WhiteLabelGrossProfitWithApsCohort = 'wl_gross_profit_with_aps_cohort',

    WhiteLabelProfitShareWithAps = 'wl_profit_share_publisher_with_aps',
    WhiteLabelProfitShareWithApsCalendar = 'wl_profit_share_publisher_with_aps_calendar',
    WhiteLabelProfitShareWithApsCohort = 'wl_profit_share_publisher_with_aps_cohort',

    EventUniqueUsers = 'event_unique_users',
    EventCount = 'event_count',
    EventRatio = 'event_ratio',
    EventConversion = 'event_conversion',
    EventRevenue = 'event_revenue',
    EventRevenuePerUser = 'event_revenue_per_user',
    InstallsDc = 'installs_dc',

    SpendDirect = 'spend_direct',
    SpendReconciliation = 'spend_reconciliation',
    SpendReconciliationPer = 'spend_reconciliation_per',

    IosRevenueByNetworkForecast = 'ios_revenue_by_network_forecast',
    IosRevenueBySsotForecast = 'ios_revenue_by_ssot_forecast',
    IosArpuByNetworkForecast = 'ios_arpu_by_network_forecast',
    IosArpuBySsotForecast = 'ios_arpu_by_ssot_forecast',
    IosRoasByNetworkForecast = 'ios_roas_by_network_forecast',
    IosRoasBySsotForecast = 'ios_roas_by_ssot_forecast',

    SentryCrashPerUser = 'sentry_crash_per_user',
    SentryCrashPerSession = 'sentry_crash_per_session',
    SentryCrashFreeUser = 'sentry_crash_free_user',
    SentryCrashFreeSession = 'sentry_crash_free_session',
    SentryCrashCount = 'sentry_crash_count',
    SentryCrashUserCount = 'sentry_crash_user_count',
    SentryCrashSessionCount = 'sentry_crash_session_count',
    SentryAnrPerUser = 'sentry_anr_per_user',
    SentryAnrPerSession = 'sentry_anr_per_session',
    SentryAnrFreeUser = 'sentry_anr_free_user',
    SentryAnrFreeSession = 'sentry_anr_free_session',
    SentryAnrCount = 'sentry_anr_count',
    SentryAnrUserCount = 'sentry_anr_user_count',
    SentryAnrSessionCount = 'sentry_anr_session_count',
    SentryNativePerUser = 'sentry_native_per_user',
    SentryNativePerSession = 'sentry_native_per_session',
    SentryNativeFreeUser = 'sentry_native_free_user',
    SentryNativeFreeSession = 'sentry_native_free_session',
    SentryNativeCount = 'sentry_native_count',
    SentryNativeUserCount = 'sentry_native_user_count',
    SentryNativeSessionCount = 'sentry_native_session_count',
    SentryErrorsPerUser = 'sentry_errors_per_user',
    SentryErrorsPerSession = 'sentry_errors_per_session',
    SentryErrorsFreeUser = 'sentry_errors_free_user',
    SentryErrorsFreeSession = 'sentry_errors_free_session',
    SentryErrorsCount = 'sentry_errors_count',
    SentryErrorsUserCount = 'sentry_errors_user_count',
    SentryErrorsSessionCount = 'sentry_errors_session_count',
}

export enum MeasureTypes {
    SUM,
    AVG,
    CUSTOM,
}

export const MeasureType = {
    [KnownMeasure.Impressions]: MeasureTypes.SUM,
    [KnownMeasure.Clicks]: MeasureTypes.SUM,
    [KnownMeasure.Requests]: MeasureTypes.SUM,
    [KnownMeasure.Fills]: MeasureTypes.SUM,
    [KnownMeasure.SessionsCount]: MeasureTypes.SUM,
    [KnownMeasure.ActiveUsersPerAd]: MeasureTypes.SUM,
    [KnownMeasure.ActiveUsers]: MeasureTypes.SUM,
    [KnownMeasure.DAU]: MeasureTypes.SUM,
    [KnownMeasure.ARPDAU]: MeasureTypes.AVG,
    [KnownMeasure.IAP_ARPDAU]: MeasureTypes.AVG,
    [KnownMeasure.TOTAL_ARPDAU]: MeasureTypes.AVG,
    [KnownMeasure.ManagedARPDAU]: MeasureTypes.AVG,
    [KnownMeasure.TotalManagedARPDAU]: MeasureTypes.AVG,
    [KnownMeasure.AFPDAU]: MeasureTypes.AVG,
    [KnownMeasure.AdEngagedUsers]: MeasureTypes.SUM,
    [KnownMeasure.NumberOfPurchases]: MeasureTypes.SUM,
    [KnownMeasure.AdRevenue]: MeasureTypes.SUM,
    [KnownMeasure.EngagementRate]: MeasureTypes.AVG,
    [KnownMeasure.AvgTimeSpentPerUser]: MeasureTypes.AVG,
    [KnownMeasure.ImpressionsPerSession]: MeasureTypes.AVG,
    [KnownMeasure.Fillrate]: MeasureTypes.AVG,
    [KnownMeasure.Ctr]: MeasureTypes.AVG,
    [KnownMeasure.Ecpm]: MeasureTypes.AVG,
    [KnownMeasure.RetentionRate]: MeasureTypes.AVG,
    [KnownMeasure.RetentionRateOrganic]: MeasureTypes.AVG,
    [KnownMeasure.Whales]: MeasureTypes.CUSTOM,
    [KnownMeasure.EcpmDecay]: MeasureTypes.CUSTOM,
    [KnownMeasure.Arpu]: MeasureTypes.AVG,
    [KnownMeasure.AFPU]: MeasureTypes.AVG,
    [KnownMeasure.Arpeu]: MeasureTypes.AVG,
    [KnownMeasure.Roas]: MeasureTypes.AVG,
    [KnownMeasure.eRoasToDate]: MeasureTypes.AVG,
    [KnownMeasure.eRoasWithAgencyProfitShareToDate]: MeasureTypes.AVG,
    [KnownMeasure.RoasActual]: MeasureTypes.AVG,
    [KnownMeasure.ProfitLoss]: MeasureTypes.SUM,
    [KnownMeasure.ProfitLossWithAgencyProfitShare]: MeasureTypes.SUM,
    [KnownMeasure.RevenueForecast]: MeasureTypes.SUM,
    [KnownMeasure.CumulativeAdRevenueForecast]: MeasureTypes.SUM,
    [KnownMeasure.ArpeuForecast]: MeasureTypes.AVG,
    [KnownMeasure.RoasForecast]: MeasureTypes.AVG,
    [KnownMeasure.ProfitForecast]: MeasureTypes.SUM,
    [KnownMeasure.Cpi]: MeasureTypes.AVG,
    [KnownMeasure.CostPerNetworkInstall]: MeasureTypes.AVG,
    [KnownMeasure.Spend]: MeasureTypes.SUM,
    [KnownMeasure.SpendDirect]: MeasureTypes.SUM,
    [KnownMeasure.SpendReconciliation]: MeasureTypes.SUM,
    [KnownMeasure.SpendReconciliationPer]: MeasureTypes.AVG,
    [KnownMeasure.MarketingCosts]: MeasureTypes.SUM,
    [KnownMeasure.ChardonnayExpenses]: MeasureTypes.SUM,
    [KnownMeasure.ChardonnayExpensesCalendar]: MeasureTypes.SUM,
    [KnownMeasure.ChardonnayExpensesCohort]: MeasureTypes.SUM,
    [KnownMeasure.MarketingCostsCalendar]: MeasureTypes.SUM,
    [KnownMeasure.MarketingCostsCohort]: MeasureTypes.SUM,
    [KnownMeasure.MarketingProfit]: MeasureTypes.SUM,
    [KnownMeasure.MarketingProfitCalendar]: MeasureTypes.SUM,
    [KnownMeasure.MarketingProfitCohort]: MeasureTypes.SUM,
    [KnownMeasure.MarketingProfitForecast]: MeasureTypes.SUM,
    [KnownMeasure.MediaSpend]: MeasureTypes.SUM,
    [KnownMeasure.MediaProfit]: MeasureTypes.SUM,
    [KnownMeasure.MediaProfitCalendar]: MeasureTypes.SUM,
    [KnownMeasure.MediaProfitCohort]: MeasureTypes.SUM,
    [KnownMeasure.MediaProfitForecast]: MeasureTypes.SUM,
    [KnownMeasure.MediaRoas]: MeasureTypes.AVG,
    [KnownMeasure.MediaRoasCalendar]: MeasureTypes.AVG,
    [KnownMeasure.MediaRoasCohort]: MeasureTypes.AVG,
    [KnownMeasure.MediaRoasForecast]: MeasureTypes.AVG,
    [KnownMeasure.Romi]: MeasureTypes.AVG,
    [KnownMeasure.ChardonnayRoi]: MeasureTypes.AVG,
    [KnownMeasure.ChardonnayRoiToDate]: MeasureTypes.AVG,
    [KnownMeasure.ChardonnayRoiCalendar]: MeasureTypes.AVG,
    [KnownMeasure.ChardonnayRoiCohort]: MeasureTypes.AVG,
    [KnownMeasure.ChardonnayRoiForecast]: MeasureTypes.AVG,
    [KnownMeasure.RomiCalendar]: MeasureTypes.AVG,
    [KnownMeasure.RomiCohort]: MeasureTypes.AVG,
    [KnownMeasure.RomiForecast]: MeasureTypes.AVG,
    [KnownMeasure.Installs]: MeasureTypes.SUM,
    [KnownMeasure.eInstalls]: MeasureTypes.SUM,
    [KnownMeasure.ManagedRevenue]: MeasureTypes.SUM,
    [KnownMeasure.ManagedEcpm]: MeasureTypes.AVG,
    [KnownMeasure.CtrUA]: MeasureTypes.AVG,
    [KnownMeasure.CvrUA]: MeasureTypes.AVG,
    [KnownMeasure.MediationFee]: MeasureTypes.SUM,
    [KnownMeasure.MediationFeePercent]: MeasureTypes.AVG,
    [KnownMeasure.RevisedClicksCount]: MeasureTypes.SUM,
    [KnownMeasure.RevisedClicks]: MeasureTypes.AVG,
    [KnownMeasure.RevisedImpressionsCount]: MeasureTypes.SUM,
    [KnownMeasure.RevisedImpressions]: MeasureTypes.AVG,
    [KnownMeasure.RevisedCtr]: MeasureTypes.AVG,
    [KnownMeasure.RevisedEcpm]: MeasureTypes.AVG,
    [KnownMeasure.DisplayRate]: MeasureTypes.AVG,
    [KnownMeasure.eROAS]: MeasureTypes.AVG,
    [KnownMeasure.eROASWithAgencyProfitShare]: MeasureTypes.AVG,
    [KnownMeasure.RetentionRateForecast]: MeasureTypes.AVG,
    [KnownMeasure.ATTOptInRate]: MeasureTypes.AVG,
    [KnownMeasure.SessionLength]: MeasureTypes.AVG,
    [KnownMeasure.AvgTimeSpentPerUserDaily]: MeasureTypes.AVG,
    [KnownMeasure.AvgTimeSpentPerUserMonthly]: MeasureTypes.AVG,
    [KnownMeasure.AvgTimeSpentPerUserLifeTime]: MeasureTypes.AVG,
    [KnownMeasure.AvgUserSessionLength]: MeasureTypes.AVG,
    [KnownMeasure.FullSessionLength]: MeasureTypes.AVG,
    [KnownMeasure.FullTimeSpentPerUser]: MeasureTypes.AVG,
    [KnownMeasure.IapRevenue]: MeasureTypes.SUM,
    [KnownMeasure.IapRefunds]: MeasureTypes.SUM,
    [KnownMeasure.IapRevenueBeforeFees]: MeasureTypes.SUM,
    [KnownMeasure.IapRevenueAfterRefunds]: MeasureTypes.SUM,
    [KnownMeasure.TotalRevenue]: MeasureTypes.SUM,
    [KnownMeasure.TotalRevenueCalendar]: MeasureTypes.SUM,
    [KnownMeasure.TotalRevenueCohort]: MeasureTypes.SUM,
    [KnownMeasure.CumulativeRevenueForecast]: MeasureTypes.SUM,
    [KnownMeasure.CumulativeRevenue]: MeasureTypes.SUM,
    [KnownMeasure.eRevenue]: MeasureTypes.SUM,
    [KnownMeasure.SubsRevenue]: MeasureTypes.SUM,
    [KnownMeasure.Profit]: MeasureTypes.SUM,
    [KnownMeasure.eProfit]: MeasureTypes.SUM,
    [KnownMeasure.eProfitForecastWithAgencyProfitShare]: MeasureTypes.SUM,
    [KnownMeasure.AgencyProfitShare]: MeasureTypes.SUM,
    [KnownMeasure.AgencyProfitShareCalendar]: MeasureTypes.SUM,
    [KnownMeasure.AgencyProfitShareCohort]: MeasureTypes.SUM,
    [KnownMeasure.AttributionCosts]: MeasureTypes.SUM,
    [KnownMeasure.BudgetUsedPercent]: MeasureTypes.AVG,
    [KnownMeasure.EventConversion]: MeasureTypes.AVG,
    [KnownMeasure.EventRatio]: MeasureTypes.AVG,
    [KnownMeasure.EventCount]: MeasureTypes.SUM,
    [KnownMeasure.EventUniqueUsers]: MeasureTypes.SUM,
    [KnownMeasure.EventRevenue]: MeasureTypes.SUM,
    [KnownMeasure.EventRevenuePerUser]: MeasureTypes.AVG,
    [KnownMeasure.InstallsDc]: MeasureTypes.AVG,
    [KnownMeasure.SentryCrashPerUser]: MeasureTypes.AVG,
    [KnownMeasure.SentryCrashPerSession]: MeasureTypes.AVG,
    [KnownMeasure.SentryCrashFreeUser]: MeasureTypes.AVG,
    [KnownMeasure.SentryCrashFreeSession]: MeasureTypes.AVG,
    [KnownMeasure.SentryCrashCount]: MeasureTypes.SUM,
    [KnownMeasure.SentryCrashUserCount]: MeasureTypes.SUM,
    [KnownMeasure.SentryCrashSessionCount]: MeasureTypes.SUM,
    [KnownMeasure.SentryAnrPerUser]: MeasureTypes.AVG,
    [KnownMeasure.SentryAnrPerSession]: MeasureTypes.AVG,
    [KnownMeasure.SentryAnrFreeUser]: MeasureTypes.AVG,
    [KnownMeasure.SentryAnrFreeSession]: MeasureTypes.AVG,
    [KnownMeasure.SentryAnrCount]: MeasureTypes.SUM,
    [KnownMeasure.SentryAnrUserCount]: MeasureTypes.SUM,
    [KnownMeasure.SentryAnrSessionCount]: MeasureTypes.SUM,
    [KnownMeasure.SentryNativePerUser]: MeasureTypes.AVG,
    [KnownMeasure.SentryNativePerSession]: MeasureTypes.AVG,
    [KnownMeasure.SentryNativeFreeUser]: MeasureTypes.AVG,
    [KnownMeasure.SentryNativeFreeSession]: MeasureTypes.AVG,
    [KnownMeasure.SentryNativeCount]: MeasureTypes.SUM,
    [KnownMeasure.SentryNativeUserCount]: MeasureTypes.SUM,
    [KnownMeasure.SentryNativeSessionCount]: MeasureTypes.SUM,
    [KnownMeasure.SentryErrorsPerUser]: MeasureTypes.AVG,
    [KnownMeasure.SentryErrorsPerSession]: MeasureTypes.AVG,
    [KnownMeasure.SentryErrorsFreeUser]: MeasureTypes.AVG,
    [KnownMeasure.SentryErrorsFreeSession]: MeasureTypes.AVG,
    [KnownMeasure.SentryErrorsCount]: MeasureTypes.SUM,
    [KnownMeasure.SentryErrorsUserCount]: MeasureTypes.SUM,
    [KnownMeasure.SentryErrorsSessionCount]: MeasureTypes.SUM,
};


export const DimensionList: { id: Dimension; label: string }[] = [
    {
        id: Dimension.Time,
        label: 'Activity Date'
    },
    {
        id: Dimension.App,
        label: 'App '
    },
    {
        id: GraphQLDimension.USER,
        label: 'Appodeal User '
    },
    {
        id: Dimension.InstallDate,
        label: 'Install Date '
    },
    {
        id: Dimension.AdType,
        label: 'Legacy Ad Type '
    },
    {
        id: Dimension.DisplayAdType,
        label: 'Ad Type '
    },
    {
        id: Dimension.Country,
        label: 'Country '
    },
    {
        id: Dimension.AdNetwork,
        label: 'Network (Monetization)'
    },
    {
        id: Dimension.LineItem,
        label: 'Line Items '
    },
    {
        id: Dimension.Placement,
        label: 'Placement (Monetization)'
    },
    {
        id: Dimension.Segment,
        label: 'Appodeal Segment '
    },
    {
        id: Dimension.OS,
        label: 'OS '
    },
    {
        id: Dimension.package_version,
        label: 'Package Version '
    },
    {
        id: Dimension.install_package_version,
        label: 'Install Package Version'
    },
    {
        id: Dimension.sdk_version,
        label: 'SDK Version '
    },
    {
        id: Dimension.os_version,
        label: 'OS Version '
    },
    {
        id: Dimension.ZeroIdfa,
        label: 'Zero Idfa '
    },
    {
        id: Dimension.ZeroMMPId,
        label: 'Zero MMP Id '
    },
    {
        id: GraphQLDimension.ATTRIBUTION_PARTNER as any,
        label: 'Agency'
    },
    {
        id: GraphQLDimension.ATTRIBUTION_PARTNER_SOURCE as any,
        label: 'Agency (Source)'
    },
    // DEPRECATED
    {
        id: Dimension.attribution_network,
        label: 'Network UA'
    },
    // DEPRECATED
    {
        id: Dimension.attribution_campaign,
        label: 'Campaign UA'
    },
    // DEPRECATED
    {
        id: Dimension.attribution_ad_set,
        label: 'AdSet UA'
    },
    {
        id: Dimension.attribution_creative,
        label: 'Creative UA'
    },
    {
        id: GraphQLDimension.ATTRIBUTION_SOURCE,
        label: 'Placement (UA)'
    },
    {
        id: GraphQLDimension.ATTRIBUTION_SOURCE_APP,
        label: 'Source App (UA)'
    },
    {
        id: Dimension.attribution_network_hid,
        label: 'Network (UA)'
    },
    {
        id: Dimension.attribution_campaign_hid,
        label: 'Campaign (UA)'
    },
    {
        id: Dimension.attribution_ad_set_hid,
        label: 'AdSet (UA)'
    },
    {
        id: Dimension.attribution_creative_hid,
        label: 'Creative (UA)'
    },
    {
        id: Dimension.keywords,
        label: 'Keywords '
    },
    {
        id: Dimension.attribution_search_keywords,
        label: 'Search Keywords'
    },
    {
        id: Dimension.attribution_search_keywords_ids,
        label: 'Search Keywords ID'
    },
    {
        id: GraphQLDimension.CONNECTION_TYPE as any,
        label: 'Connection Type '
    },
    {
        id: Dimension.manufacturer,
        label: 'Manufacturer '
    },
    {
        id: Dimension.model,
        label: 'Model '
    },
    {
        id: Dimension.device_type,
        label: 'Device Type '
    },
    {
        id: GraphQLDimension.NETWORK_ACCOUNT as any,
        label: 'Network Account (Monetization)'
    },
    {
        id: GraphQLDimension.FRAMEWORK as any,
        label: 'Framework '
    },
    {
        id: GraphQLDimension.FRAMEWORK_VERSION as any,
        label: 'Framework Version'
    },
    {
        id: GraphQLDimension.PLUGIN_VERSION as any,
        label: 'Plugin Version'
    },
    {
        id: Dimension.attribution_campaign_status as any,
        label: 'Campaign (UA) Status'
    },
    {
        id: Dimension.ua_status as any,
        label: 'UA Status'
    },
    {
        id: Dimension.auto_bid as any,
        label: 'Auto Bid'
    },
    {
        id: Dimension.hist_campaign_status as any,
        label: 'Historical Status(Campaign)'
    },
    {
        id: Dimension.hist_campaign_type as any,
        label: 'Historical Type(Campaign)'
    },
    {
        id: Dimension.hist_campaign_auto_bid as any,
        label: 'Historical Auto Bid(Campaign)'
    },
    {
        id: Dimension.hist_campaign_payback_period as any,
        label: 'Historical Campaign Payback Period'
    },
    {
        id: Dimension.hist_ad_set_status as any,
        label: 'Historical Status(Ad Set)'
    },
    {
        id: Dimension.hist_ad_set_auto_bid as any,
        label: 'Historical Auto Bid(Ad Set)'
    },
    {
        id: Dimension.hist_ad_set_payback_period as any,
        label: 'Historical Ad Set Payback Period'
    },
    {
        id: Dimension.hist_country_status as any,
        label: 'Historical Status(Country)'
    },
    {
        id: Dimension.hist_country_auto_bid as any,
        label: 'Historical Auto Bid(Country)'
    },
    {
        id: Dimension.hist_country_payback_period as any,
        label: 'Historical Country Payback Period'
    },
    {
        id: Dimension.hist_source_app_status as any,
        label: 'Historical Status(Source App)'
    },
    {
        id: Dimension.hist_source_app_auto_bid as any,
        label: 'Historical Auto Bid(Source App)'
    },
    {
        id: Dimension.hist_source_app_payback_period as any,
        label: 'Historical Source App Payback Period'
    },
    {
        id: Dimension.mmp as any,
        label: 'MMP'
    },
    {
        id: Dimension.parallel_bidding as any,
        label: 'In-App Header Bidding'
    },
    {
        id: Dimension.waterfall_configuration as any,
        label: 'Waterfall configuration'
    },
    {
        id: Dimension.day_since_install as any,
        label: 'Day Since Install'
    },
    {
        id: Dimension.post_bid as any,
        label: 'Post Bid'
    },
    {
        id: Dimension.round_number as any,
        label: 'Round Number'
    },
    {
        id: Dimension.ad_request_floor_range as any,
        label: 'Ad Request Floor Range'
    },
    {
        id: Dimension.bid_floor_range as any,
        label: 'Bid Floor Range'
    },
    {
        id: Dimension.bid_price_range as any,
        label: 'Bid Price Range'
    },
    {
        id: Dimension.white_label_publisher as any,
        label: 'White Label Publisher'
    },
    {
        id: Dimension.funnel as any,
        label: 'Funnel'
    },
    {
        id: Dimension.is_organic as any,
        label: 'Is Organic (UA)'
    },
    {
        id: Dimension.bidmanager_creative_hid as any,
        label: 'BidManager Creative (Ua)'
    },
    {
        id: Dimension.appodeal_account as any,
        label: 'Appodeal Account'
    },
    {
        id: Dimension.mediation as any,
        label: 'Mediation Platform'
    },
    {
        id: Dimension.mediation_group as any,
        label: 'Mediation Group'
    },
    {
        id: Dimension.install_mediation as any,
        label: 'Install Mediation Platform'
    },
    {
        id: Dimension.event_name as any,
        label: 'Event Name'
    },
    {
        id: Dimension.event_source as any,
        label: 'Event Source'
    },
    {
        id: Dimension.is_chardonnay as any,
        label: 'Chardonnay Account'
    },
    {
        id: Dimension.monetization_engine as any,
        label: 'Monetization Engine'
    },
    {
        id: Dimension.user_created_date as any,
        label: 'User Created Date'
    },
    {
        id: Dimension.app_created_date as any,
        label: 'App Created Date'
    },
    {
        id: Dimension.studio as any,
        label: 'Studio'
    },
    {
        id: Dimension.revenue_manager as any,
        label: 'Revenue Manager'
    },
    {
        id: Dimension.attribution_agency as any,
        label: 'Attribution Agency'
    },
    {
        id: Dimension.is_claimed_by_publisher as any,
        label: 'Is Claimed By Publisher'
    }
];

export enum AppSplit {
    Name = 'name',
    BundleId = 'bundle',
    ID = 'id'
}

export const appSplitOptions = [
    {label: 'Name', value: AppSplit.Name},
    {label: 'BundleId', value: AppSplit.BundleId},
    {label: 'Appodeal App ID', value: AppSplit.ID}
];

export const accountOptions = [
    {label: 'Name', value: AppSplit.Name},
    {label: 'Account ID', value: AppSplit.ID}
];

export enum TimeBucket {
    DAY = 'DAY',
    WEEK = 'WEEK',
    MONTH = 'MONTH',
    QUARTER = 'QUARTER'
}

export const timeDimensionOptions = [
    {label: 'Day', value: TimeBucket.DAY},
    {label: 'Week', value: TimeBucket.WEEK},
    {label: 'Month', value: TimeBucket.MONTH},
    {label: 'Quarter', value: TimeBucket.QUARTER}
];

export enum ReportsAdType {
    // full screen add
    Interstitial = '1',
    // @deprecated
    DeprecatedVideoInterstitial = '2',
    Banner = '3',
    NativeAds = '4',
    Mrec = '5',
    RewardedVideo = '6'
}

export const Organic = 'Organic';
